import type { RouteRecordRaw } from 'vue-router'

import { generateWebviewRoutes } from '~/scopes/webviews/generateWebviewRoutes'

import redirectIfWebview from '../webviews/middleware/redirectIfWebview'

import { OUTLET } from './routes-names'

// We expose the outlet pages on both the standard URL space and the webview
// namespace via `generateWebviewRoutes`. The detail route is namespaced under
// `/product` so the `:slug` of the category list can't swallow a product id.
export default (): RouteRecordRaw[] => {
  const outletRoutes: RouteRecordRaw[] = [
    {
      path: 'outlet',
      name: OUTLET.HOME,
      component: () =>
        import('~/scopes/outlet/pages/OutletHome/OutletHome.vue'),
      meta: {
        // The outlet is a standalone, full-screen experience with its own
        // chrome — no marketplace header/footer.
        layout: false,
        owners: ['bot-squad-acquisition-front'],
        middleware: [redirectIfWebview],
      },
    },
    {
      path: 'outlet/product/:id',
      name: OUTLET.DETAIL,
      component: () =>
        import('~/scopes/outlet/pages/OutletDetail/OutletDetail.vue'),
      meta: {
        // The outlet is a standalone, full-screen experience with its own
        // chrome — no marketplace header/footer.
        layout: false,
        owners: ['bot-squad-acquisition-front'],
        middleware: [redirectIfWebview],
      },
    },
    {
      path: 'outlet/:slug',
      name: OUTLET.CATEGORY,
      component: () =>
        import('~/scopes/outlet/pages/OutletCategory/OutletCategory.vue'),
      meta: {
        // The outlet is a standalone, full-screen experience with its own
        // chrome — no marketplace header/footer.
        layout: false,
        owners: ['bot-squad-acquisition-front'],
        middleware: [redirectIfWebview],
      },
    },
  ]

  const webviewOutletRoutes = generateWebviewRoutes(outletRoutes)

  return [...outletRoutes, ...webviewOutletRoutes]
}
